function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 14,
  rx: 1.5,
  stroke: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11L9.73205 5.6906L6.26795 10.3094L12 11ZM3.7 5.4L7.7 8.4L8.3 7.6L4.3 4.6L3.7 5.4ZM7.7 8.4L8.1 8.7L8.7 7.9L8.3 7.6L7.7 8.4Z",
  fill: "#00BB77"
});
const SvgTransitionIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransitionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transition_icon.8a910593.svg";
export { ForwardRef as ReactComponent };